import { Component } from '@angular/core';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { StorageService } from '../../../core/storage/storageService';
import { SearchService } from '../../../models/search/searchService';
import { GlobalSearchRecord } from '../../../models/search/GlobalSearchRecord';
import { SearchFilters } from '../../../models/search/searchFilters';
import { UIErrorHandler } from '../../../core/uiErrorHandler';

@Component({
  selector: 'global-search-table-view',
  templateUrl: './global-search-table-view.component.html',
  standalone: false,
})
export class GlobalSearchTableViewComponent extends TableViewAbstractComponent {
  constructor(
    public searchService: SearchService,
    private storage: StorageService,
    private uiErrorHandler: UIErrorHandler,
  ) {
    super();
  }

  formatDetails(type: string, details: any) {
    let html = details;

    if (type != '' && details != null) {
      let oDetails = JSON.parse(details);

      switch (type) {
        case 'business':
          html = oDetails.emailAddress;
          break;

        case 'customer':
          html = oDetails.emailAddress;
          break;

        case 'merchant':
          html = 'MID: ' + oDetails.mid + ', Location: ' + oDetails.street1;
          break;

        case 'transaction':
          html =
            oDetails.firstName +
            ' ' +
            oDetails.lastName +
            ' | ' +
            oDetails.cardType +
            ' ' +
            oDetails.cardNum +
            ' $' +
            oDetails.amount;
          break;

        case 'user':
          html = oDetails.emailAddress;
          break;

        default:
          break;
      }
    }

    return html;
  }

  getRecordFromDataSource(recordId: string): GlobalSearchRecord {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == recordId) {
        return this.dataSource.data[i];
      }
    }

    throw 'record not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: SearchFilters,
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<GlobalSearchRecord>> {
    return this.searchService
      .doOmniSearch(query, filters, {
        pageNum: pageNum,
        pageSize: pageSize,
        orderBy: 'name',
        sortColumn: sortColumn,
        sortDirection: sortDirection,
      })
      .then((results) => {
        return results;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
        return new Page<GlobalSearchRecord>({});
      });
  }

  canQuery(): boolean {
    return true;
  }

  filterByLetter_click(letter: string) {
    //console.log("letter = " + letter)
  }

  getTypeTitle(type: string): string {
    switch (type) {
      case 'business':
        return 'Business';
        break;

      case 'customer':
        return 'Customer';
        break;

      case 'merchant':
        return 'Merchant';
        break;

      case 'transaction':
        return 'Transaction';
        break;

      case 'user':
        return 'User';
        break;

      default:
        return '';
    }
  }

  getTypeIcon(type: string): string {
    switch (type) {
      case 'business':
        return 'location_city'; //domain grid_on filter_none apps more layers
        break;

      case 'customer':
        return 'group'; //wc people people_outline
        break;

      case 'merchant':
        return 'store'; //store_mall_directory
        break;

      case 'transaction':
        return 'shopping_cart'; //receipt local_grocery_store credit_card attach_money
        break;

      case 'user':
        return 'person'; //person_outline account_circle account_box
        break;

      default:
        return '';
    }
  }
}
